/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Speed_SettingsInputs */



/**
* | output |
* | --- |
* | "Reading Speed Settings" |
*
* @param {Reading_Speed_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reading_speed_settings = /** @type {((inputs?: Reading_Speed_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Speed_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de vitesse de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für die Lesegeschwindigkeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni della velocità di lettura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки скорости чтения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de velocidad de lectura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阅读速度设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み取り速度設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पठन गति सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de velocidade de leitura")
	return /** @type {LocalizedString} */ ("Reading Speed Settings")
});